/* global Vue */
(function () {
	var uuid = 0;

	Vue.uuidToInstance = {};
	Vue.getInstanceByUUID = function (uuid) {
		return Vue.uuidToInstance[uuid];
	};

	Vue.mixin({
		beforeCreate: function () {
			this.uuid = uuid.toString();
			Vue.uuidToInstance[this.uuid] = this;
			uuid++;
		},
		beforeDestroy: function () {
			delete Vue.uuidToInstance[this.uuid];
		}
	});
})();